import { useState, useCallback, useMemo } from 'react';
import { getServices, getProfile, getTownHalls } from '../services/vendorAPI';

const useVendor = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchServicesByVendor = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getServices();
      setLoading(false);
      return response;
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError(err);
      return { success: false, error: err.message };
    }
  }, []);

  const fetchVenderById = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getProfile();
      if (response.success) {
        setLoading(false);
        return { result: true, ...response.data };
      } else {
        setLoading(false);
        return { result: false };
      }
    } catch (error) {
      setLoading(false);
      return { result: false };
    }
  }, []);

  const fetchHallsByVendor = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getTownHalls();
      setLoading(false);
      return response;
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError(err);
      return { success: false, error: err.message };
    }
  }, []);

  return useMemo(() => ({
    loading,
    error,
    fetchServicesByVendor,
    fetchVenderById,
    fetchHallsByVendor,
  }), [loading, error, fetchServicesByVendor, fetchVenderById, fetchHallsByVendor]);
};

export default useVendor;
